"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARCHIVE_LIMITS = exports.BLOCKED_DIRECTORIES = exports.UPLOAD_LIMITS = void 0;
exports.UPLOAD_LIMITS = {
    MAX_FILES: 10000,
    MAX_TOTAL_MB: 20 * 1024,
    MAX_TOTAL_BYTES: 20 * 1024 * 1024 * 1024,
    MAX_FILE_SIZE_MB: 100,
    MAX_FILE_SIZE_BYTES: 100 * 1024 * 1024,
    MAX_PATH_DEPTH: 10,
    MAX_PATH_LENGTH: 500,
};
exports.BLOCKED_DIRECTORIES = [
    '.git',
    '.svn',
    '.hg',
    'node_modules',
    '__pycache__',
    '.DS_Store',
    '__MACOSX',
];
exports.ARCHIVE_LIMITS = {
    MAX_EXPANDED_BYTES: 512 * 1024 * 1024,
    MAX_COMPRESSION_RATIO: 100,
};
//# sourceMappingURL=upload-constants.js.map